import { getBaseUrl } from '../api.utils'
import { Batch } from '../../types'
import { Api } from '../api.types'

export class FetchApi implements Api {
  #debug = false
  #baseUrl: string
  #options = {
    method: 'POST',
    // https://developer.mozilla.org/en-US/docs/Web/API/fetch#keepalive
    keepalive: true,
    headers: {},
  }

  constructor(platform: string, publicApiKey: string, acceptLanguage?: string, debug = false, apiUrl?: string) {
    this.#debug = debug
    // eslint-disable-next-line @typescript-eslint/naming-convention
    this.#options.headers = { 'X-Platform': platform, 'public-api-key': publicApiKey, 'Content-Type': 'application/json', 'accept-language': acceptLanguage }
    this.#baseUrl = apiUrl ?? getBaseUrl(publicApiKey)
  }

  sendBatch(batches: Batch[]): Promise<null> {
    if (this.#debug) {
      console.dir(batches, { depth: null })
    }

    return fetch(`${this.#baseUrl}/v1/sdk/event-log/publish`, {
      ...this.#options,
      body: JSON.stringify({ batch: batches }),
    }).then((response) => response.json())
  }

  sendMetricsBatch(batches: Batch[]): Promise<null> {
    if (this.#debug) {
      console.dir(batches, { depth: null })
    }

    return fetch(`${this.#baseUrl}/v1/sdk/performance/publish`, {
      ...this.#options,
      body: JSON.stringify({ batch: batches }),
    }).then((response) => response.json())
  }
}
